
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 85.337h512v341.326H0z"}}),_c('path',{attrs:{"d":"M114.024 256.001L0 141.926v228.17z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M161.192 256L0 94.7v47.226l114.024 114.075L0 370.096v47.138z"}}),_c('path',{attrs:{"fill":"#6DA544","d":"M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z"}}),_c('path',{attrs:{"fill":"#0052B4","d":"M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M503.181 189.217H512V85.337H132.552l103.881 103.88z"}})])
          )
        }
      }
    